import { useCallback, useEffect, useState } from 'react';
import AppLayout from '../../component/appLayout';
import { HeaderTitle, Heading, Icon, LeftSide, Main, RightSide, SnapHeader, Snaps } from './styles';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import Button from '../../component/button';
import SnapRecordModal from '../../component/modals/snapRecordModal';
import SnapCardView from '../../component/snapCardView';
import Modal from '../../component/modals/modal';
import { getSnapListByUser } from '../../services/snapService';
import UserPreferenceSingleton from '../../helpers/userPreferenceSingleton';
import { calculateDueTime, isMediaRecordingSupported } from '../../helpers/common';
import { rootStore } from '../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { BUTTON_TYPE, EMPTY_STATE_SIZE, ICON_SIZE } from '../../global/constants';
import { useMobileDevice } from '../../global/useMobile';
import ResponsiveHeader from '../../component/responsiveHeader';
import BottomSubNavigation from '../../component/bottomNavigation/subNavigation';
import EmptyStateV2 from '../../component/emptyState';

const Snap: React.FC = () => {
  // States
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<string | null>(null);
  //Mobx store variables
  const { appStore } = rootStore;
  const { snapList } = appStore;
  // Other variables
  const isMobile = useMobileDevice();
  const currentUser = UserPreferenceSingleton.getInstance().getCurrentUser();

  const loadData = useCallback(async () => {
    await getSnapListByUser();
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <AppLayout>
        <Main className='desktop-content'>
          {!isMobile ? (
            <SnapHeader>
              <HeaderTitle>
                <LeftSide>
                  <Icon>
                    <SVGIcon
                      name='snap-icon'
                      width={ICON_SIZE.XXXL}
                      height={ICON_SIZE.XXXL}
                      viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                      fill='var(--brand-primary)'
                    />
                  </Icon>
                  <Heading>Snap</Heading>
                </LeftSide>
              </HeaderTitle>
              {snapList?.length !== 0 && (
                <RightSide>
                  <Button
                    variant={BUTTON_TYPE.PRIMARY}
                    iconPosition='start'
                    title='New Snap'
                    iconName='plus-icon'
                    buttonType='button'
                    onClick={handleOpenModal}
                  />
                </RightSide>
              )}
            </SnapHeader>
          ) : (
            <ResponsiveHeader title='Snap' />
          )}

          {snapList?.length <= 0 && (
            <EmptyStateV2
              size={EMPTY_STATE_SIZE.MEDIUM}
              title='You have no snap'
              description='You can Create New snap by clicking the button below'
              buttonTitle='New Snap'
              onClick={handleOpenModal}
              imageUrl='snap_record_empty'
              isAlignedCenter={true}
            />
          )}

          <Snaps>
            {snapList?.map((item) => {
              let dueResult: { dueTime?: string; dueParam?: string } | undefined;
              if (item?.CreatedTime) {
                dueResult = calculateDueTime(item?.CreatedTime);
              }
              return (
                <SnapCardView
                  key={item['_id']}
                  time={`${dueResult?.dueTime} by ${currentUser?.given_name}`}
                  loadData={loadData}
                  snapData={item}
                  selectedItem={selectedItem}
                  setSelectedItem={setSelectedItem}
                />
              );
            })}
          </Snaps>
        </Main>
      </AppLayout>
      <BottomSubNavigation />
      {isMediaRecordingSupported() && (
        <Modal open={isModalOpen} onClose={handleCloseModal} maxWidth={'258px'}>
          <SnapRecordModal handleCloseModal={handleCloseModal} />
        </Modal>
      )}
    </>
  );
};
export default observer(Snap);
